export default "481a2d759653a138.svg"